const videoSrc = {
  getSrc(value: string) {
    let arr: Array<string> = [];

    arr = value?.split(" ");

    let src = arr?.find(el => el.includes("src"));

    let regexp = /"(\\.|[^"\\])*"/g;

    let embedSrc = src
      ?.match(regexp)
      ?.join("")
      ?.slice(1)
      ?.replace(/.$/, "");

    return embedSrc ? embedSrc : value;
  }
};

export { videoSrc };
